import { type FC, useContext } from "react";

import { type ProductionGroup } from "@/schemas/production-group";
import { ProductionContext } from "@/contexts/production";

import { ProductionGroupStatusDisplay } from "../production-group-status";

interface ProductionGroupStatusProps {
	readonly selectedValue: ProductionGroup;
}

export const ProductionGroupStatus: FC<ProductionGroupStatusProps> = ({ selectedValue }) => {
	const { machineGroups, productionGroups } = useContext(ProductionContext);

	if (selectedValue === null) {
		return null;
	}

	const onlineMachineGroups = productionGroups
		.find((pg) => pg.id === selectedValue.id)
		?.configuredMachineGroups?.map((mgId) =>
			machineGroups.find((mg) => mg.id === mgId && mg.status === "Online"),
		).length;

	return <ProductionGroupStatusDisplay machineGroupsOnline={onlineMachineGroups ?? 0} />;
};
